export const POSITIONS_ENDPOINTS = {
   GET_FILTERS: () => '/positions/filters',
   SEARCH_JOBS: () => '/positions/search',
};
